import {inject, Injectable} from '@angular/core';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',

})
export class ToastService {
  private messageService = inject(MessageService);
  private translateService = inject(TranslateService);

  showMessage(message: ToastMessage) {
    message.summary = this.translateService.instant(message.summary);
    message.detail = this.translateService.instant(message.detail);
    this.messageService.add({...message, life: 5000});
  }
}

export interface ToastMessage {
  severity: 'info' | 'error';
  summary: string;
  detail: string;
}


